import React from 'react';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import combineStyles from '../../utils/combineStyles';
import LayoutStyles from '../../styles/layout';
import TypographyStyles from '../../styles/typography';

import InvoiceHeader from '../../components/invoice/InvoiceHeader';
import InvoiceDetailsSection from '../../components/invoice/DetailsSection';
import InvoicePreviewSection from '../../components/invoice/InvoicePreview';
import InvoiceDocumentsSection from '../../components/invoice/DocumentsSection';
import InvoiceCommentsSection from '../../components/invoice/CommentsSection';
import InvoiceActivitySection from '../../components/invoice/ActivitySection';

const styles = theme => ({
  bodySection: {
    padding: theme.spacing.unit * 5
  }
});

export const DetailLayout = ({ classes, invoice }) => (
  <div className={classes.root}>
    <div className={classes.headerSection}>
      <InvoiceHeader invoice={invoice} />
      <div className={classes.bodySection}>
        <Grid container spacing={40}>
          <Grid item xs={4}>
            <InvoiceDetailsSection invoice={invoice} />
            <InvoiceDocumentsSection invoice={invoice} />
            <InvoiceCommentsSection />
            <InvoiceActivitySection />
          </Grid>
          <Grid item xs={8}>
            <InvoicePreviewSection />
          </Grid>
        </Grid>
      </div>
    </div>
  </div>
);
const translatedDetailLayout = withNamespaces()(DetailLayout);

export default withStyles(
  combineStyles(styles, LayoutStyles, TypographyStyles)
)(translatedDetailLayout);
